var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customized c-width"},[_c('p',{staticClass:"title"},[_vm._v("提交您的需求，我们为您定制")]),_c('a',{staticClass:"link-btn",attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v("申请定制")])])
}
var staticRenderFns = []

export { render, staticRenderFns }